document.addEventListener("DOMContentLoaded", function () {

  const interval = setInterval(() => {
    
    const textarea =
      document.querySelector("#textarea__1772516154558") ||
      document.querySelector("textarea[name='textarea__1772516154558']");

    const emailSubject =
      document.querySelector("#text__1772856963535") ||
      document.querySelector("textarea[name='text__1772856963535']");

    const selectedSamplesDiv = document.querySelector(".intSelectedSamples");

    if (!textarea) return;

    if (textarea.value.trim() !== "") {

      emailSubject.value = "New fabric sample request";
      selectedSamplesDiv.style.display = "block";
      const h1 = document.querySelector("h1");

      if (h1) {
        h1.textContent = "Request Fabric Samples";
      }
      const h3 = document.querySelector("h3");
      if (h3) {
        h3.style.display = "none";
      }

      clearInterval(interval);
    }
    else
    {
      selectedSamplesDiv.style.display = "none";
      emailSubject.value = "Your Quote Request";
    }

  }, 200);

});